import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const GoogleReservationRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener parámetros que Google envía
    const date = searchParams.get('date');
    const time = searchParams.get('time');
    const party = searchParams.get('party');
    
    // Guardar en sessionStorage para usarlos en la página de reservas
    if (date || time || party) {
      sessionStorage.setItem('googleReservation', JSON.stringify({
        date: date || '',
        time: time || '',
        guests: party ? parseInt(party) : 2 // Ahora guardamos el número directamente
      }));
    }
    
    // Redirigir a tu página de reservas
    navigate('/');
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#e31837] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Redirigiendo al sistema de reservas...</p>
      </div>
    </div>
  );
};

export default GoogleReservationRedirect;